<template>
	<div class="px-2 d-flex align-center justify-center" style="min-height: 70px; border-left: 1px solid #eaeaea; border-right: 1px solid #eaeaea;"
		@click.stop="clickParent" v-if="isAbleToAdd">
		<v-form ref="form" v-model="validform">
			<p class="mb-0 font-weight-bold caption">Porcentaje de avance</p>
			<v-text-field
				v-model="newPaymentStatusForm.progress"
				placeholder="% Avance"
				type="number"
				outlined
				dense
				hide-details
				:height="20"
				class="custom-input-numbers text-center"
				:rules="[...requiredRule, ...percentRule]"
				@input="changeFormValue"
			>
			</v-text-field>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<div class="d-flex flex-row justify-end align-center mt-1"
						v-bind="attrs"
						v-on="on">
						<div class="d-flex flex-row align-center mr-1">
							<v-icon color="#2D4B95" class="mr-1" small>mdi-currency-usd</v-icon>
							<p class="mb-0 normal caption font-weight-bold">
								{{prependToValue}}{{additional.last_revision?.total_requested_converted*newPaymentStatusForm.progress/100 | toThousandFilter(additional.currency_info?.code === 'UF' ? 2 : 0)}}
							</p>
						</div>
					</div>
				</template>
				<span>Monto correspondiente</span>
			</v-tooltip>
		</v-form>
	</div>
	<div v-else class="d-flex flex-grow-1 text-center text-wrap">
		<small>No es posible agregar más estados de pago para este adicional</small>
	</div>
</template>
<script>
export default {
	name: 'NewPaymentStatusAdditionalForm',
	props: {
		ps: {
			type: Object,
			required: false
		},
		additional: {
			type: Object,
			required: true
		},
		onChangeProgress: {
			type: Function,
			required: true
		},
		closeForm: {
			type: Function,
			required: true
		}
	},
	computed: {
		prependToValue(){
			const code = this.additional.currency_info?.code || this.additional.last_revision.currency_info.code || ''
			const symbol = this.additional.currency_info?.symbol ||'$'
			if(code != symbol){
				return `${code} ${symbol}`
			}
			return code
		},
		percentRule() {
			if(this.additional.cost_type != 1){
				return [];
			}
			const total_progress = this.additional.total_progress*100
			return [
				v => v && v.toString().match(/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/) || 
				`El porcentaje debe estar entre 0 y 100`,
				v => v <= (100 - total_progress || 100) || 
				`El porcentaje no puede superar ${total_progress || 100}`
			];
		},
		isAbleToAdd(){
			const total_progress = this.additional.total_progress*100
			return total_progress < 100 || this.additional.cost_type != 1
		}
	},
	data: () => ({
		loading: false,
    validform: true,
		newPaymentStatusForm: {
			description: null,
			progress: null,
			amount: null
		},
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
		// percentRule: [
		// 	v => v && v.toString().match(/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/) || 'El porcentaje de avance debe estar entre 0 y 100'
		// ],
		decimalsRule: [
			v => v && v.toString().match(/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/) || 'El monto puede tener 2 decimales, formato XXXXXX.XX'
		],
	}),
	mounted() {
		this.setInitialValues()
	},
	methods: {
		clickParent(){
			console.log('clickParent')
		},
		setInitialValues(){
			if(this.ps && this.ps.additional_included && this.ps.additional_included.length > 0){
				const currentStatus = this.ps.additional_included.find(item => item.additional_id === this.additional.id)
				if(currentStatus){
					this.newPaymentStatusForm.progress = currentStatus.progress * 100
					this.newPaymentStatusForm.amount = currentStatus.amount
				}
			}
			else{
				this.newPaymentStatusForm.progress = null
				this.newPaymentStatusForm.amount = null
			}
		},
		changeFormValue(value){
			if(value <= (100 - this.additional.total_progress*100) || this.additional.cost_type != 1){
				this.onChangeProgress(value)
			}
			else{
				const maxAvailable = Math.round(100 - this.additional.total_progress*100);
				this.newPaymentStatusForm.progress = maxAvailable;
				this.onChangeProgress(maxAvailable);
        const datas = {
					message: 'El porcentaje de avance de este adicional no puede ser mayor a ' + maxAvailable + '. Se ha ajustado automáticamente al valor máximo disponible.',
					title: 'Error',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
        }
        this.$store.globalStore.dispatch('addMessage', datas)
			}
		}
	}
}
</script>

<style scoped>
	.text-primary-color{
		color: #2D4B95;
	}
	.high{
		color: #F4516C;
	}
	.medium{
		color: #fb8c00;
	}
	.normal{
		color: #3EBFA3;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;min-height: 30px!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center; font-size: 12px; padding: 0}
</style>